<h1 class="dsd-t-3">{{ 'caad.accueil.titreServiceCarteCredit' | translate }}</h1>
<p>{{ 'caad.accueil.description' | translate }}</p>
<dsd-container>
  <h2 class="dsd-t-4">{{ 'caad.accueil.vosComptes.titre' | translate }}</h2>
  <dsd-grid-row>
    <dsd-grid-col class="dsd-mb-0" sm-col="12" md-col="6" lg-col="4">
      <app-info-profil-caisse-folio [profilCaisseFolio]="infoProfilCaisseFolio"></app-info-profil-caisse-folio>
    </dsd-grid-col>
  </dsd-grid-row>
  <p>
    <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.adresse' | translate }}&nbsp;</span>
    <span class="valeur line-adresse">{{ adresse | adresse }}</span>
  </p>
  <p *ngIf="courriel">
    <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.courriel' | translate }}&nbsp;</span>
    <span class="valeur">{{ courriel }}</span>
  </p>
  <p *ngIf="telephonePrincipal">
    <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.telephone' | translate }}&nbsp;</span>
    <span class="valeur">{{ telephonePrincipal | phone }}</span>
  </p>
  <p *ngIf="telephoneSecondaire">
    <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.telephoneSecondaire' | translate }}&nbsp;</span>
    <span class="valeur">{{ telephoneSecondaire | phone }}</span>
  </p>
  <p *ngIf="telephoneTravail">
    <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.telephoneTravail' | translate }}&nbsp;</span>
    <span class="valeur">
      {{ telephoneTravail | phone }}
    </span>
  </p>

  <dsd-button variant="primary" full-width="xs" (dsdButtonClick)="allerAModification()">
    {{ 'caad.button.modifier' | translate }}
    <span class="dsd-sr-only">  {{ 'caad.accueil.vosComptes.horsEcran.boutonModifier' | translate }} </span>
  </dsd-button>
</dsd-container>

<dsd-container *ngIf="adressesSpecifiques?.length > 0">
  <h2 class="dsd-t-4">{{ 'caad.accueil.autresComptes.titre' | translate }}</h2>

  <ng-container *ngFor="let compte of adressesSpecifiques; let last = last">
    <dsd-grid-row>
      <dsd-grid-col class="dsd-mb-0" sm-col="12" md-col="6" lg-col="4">
        <app-info-profil-caisse-folio [profilCaisseFolio]="compte.profilsCaisse"></app-info-profil-caisse-folio>
      </dsd-grid-col>
    </dsd-grid-row>
    <p>
      <span class="libelle">{{ 'caad.accueil.vosComptes.libelle.adresse' | translate }}&nbsp;</span>
      <span class="valeur line-adresse">{{ compte | adresse }}</span>
    </p>
    <div *ngIf="!last" class="dsd-hr"></div>
  </ng-container>

  <p>{{ 'caad.accueil.autresComptes.description' | translate }}</p>
  <dsd-link-action type="external">
    <a href="{{ getUrlPlanifierAppel() }}">{{ 'caad.accueil.autresComptes.link' | translate }}</a>
  </dsd-link-action>
</dsd-container>

<dsd-container>
  <h2 class="dsd-t-4">{{ 'caad.accueil.credit.titre' | translate }}</h2>
  <dsd-alert variant="info" class="dsd-mb-sm">
    <h3 slot="title">{{ 'caad.accueil.alerte.horsEcran.information' | translate }}</h3>
    {{ 'caad.accueil.credit.alerte' | translate }}
  </dsd-alert>
  <p>{{ 'caad.accueil.credit.description' | translate }}</p>
  <dsd-link-action>
    <a [routerLink]="[lienCredit]" [queryParamsHandling]="lienCreditQueryParamsHandling">{{
      'caad.accueil.credit.link' | translate
    }}</a>
  </dsd-link-action>
</dsd-container>

<dsd-container>
  <h2 class="dsd-t-4">{{ 'caad.accueil.autresProduits.titre' | translate }}</h2>
  <p>{{ 'caad.accueil.autresProduits.description' | translate }}</p>
  <dsd-grid class="dsd-d-none sm:dsd-d-block">
    <dsd-grid-row>
      <dsd-grid-col class="dsd-d-flex" sm-col="4">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true" class="dsd-mb-0">
          <a slot="link" [href]="'caad.accueil.autresProduits.assurances.url' | translate"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.assurances.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.assurances.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
      <dsd-grid-col class="dsd-d-flex" sm-col="4">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true" class="dsd-mb-0">
          <a slot="link" [href]="'caad.accueil.autresProduits.securiteFinanciere.url' | translate"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.securiteFinanciere.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.securiteFinanciere.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
      <dsd-grid-col class="dsd-d-flex" sm-col="4">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true" class="dsd-mb-0">
          <a slot="link" [href]="'caad.accueil.autresProduits.laPersonnelle.url' | translate"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.laPersonnelle.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.laPersonnelle.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
    </dsd-grid-row>
  </dsd-grid>
  <dsd-grid class="dsd-d-block sm:dsd-d-none dsd-ml-0 dsd-mr-0" style="max-width: fit-content">
    <dsd-grid-row>
      <dsd-grid-col class="dsd-d-flex">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true">
          <a slot="link" [href]="'caad.accueil.autresProduits.assurances.url' | translate"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.assurances.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.assurances.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
      <dsd-grid-col class="dsd-d-flex">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true">
          <a slot="link" [href]="'caad.accueil.autresProduits.securiteFinanciere.url' | translate"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.securiteFinanciere.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.securiteFinanciere.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
      <dsd-grid-col class="dsd-d-flex">
        <dsd-tile-navigation full-width="true" variant="standard-description" external="true" class="dsd-mb-0">
          <a slot="link" [href]="'caad.accueil.autresProduits.laPersonnelle.url' | translate"></a>
          <span slot="label">{{ 'caad.accueil.autresProduits.laPersonnelle.titre' | translate }}</span>
          <span slot="description">{{ 'caad.accueil.autresProduits.laPersonnelle.description' | translate }}</span>
        </dsd-tile-navigation>
      </dsd-grid-col>
    </dsd-grid-row>
  </dsd-grid>
</dsd-container>

<app-bouton-retour />
